import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageTodayCollSearchLayer from "../../../components/Admin/ManageTodayCollSearchLayer";

const ManageTodayCollSearch = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageTodayCollSearchLayer />
      </MasterLayout>
    </>
  );
};

export default ManageTodayCollSearch
